declare namespace $ {

	type $mol_image__uri_bog_blitz_blog_menu_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_paragraph__title_bog_blitz_blog_menu_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_blitz_blog_menu_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_blitz_blog_menu_4 = $mol_type_enforce<
		ReturnType< $bog_blitz_blog_menu['nav_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_link__arg_bog_blitz_blog_menu_5 = $mol_type_enforce<
		({ 
			'screen': ReturnType< $bog_blitz_blog_menu['link_slug'] >,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_bog_blitz_blog_menu_6 = $mol_type_enforce<
		ReturnType< $bog_blitz_blog_menu['link_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	export class $bog_blitz_blog_menu extends $mol_page {
		Logo( ): $mol_image
		Heading( ): $mol_paragraph
		Subtitle( ): $mol_paragraph
		nav_rows( ): readonly(any)[]
		Nav( ): $mol_list
		link_slug( id: any): string
		link_title( id: any): string
		title( ): string
		items( ): Record<string, any>
		page( next?: string ): string
		body( ): readonly(any)[]
		Link( id: any): $mol_link
	}
	
}

//# sourceMappingURL=menu.view.tree.d.ts.map